{
  "chart": {
    "how-to-measure": "Sådan måler du",
    "select-your-size-we-ll-notify-you-once-it-s-back-in-stock": "Vælg din størrelse, så giver vi dig besked, når den er tilbage på lager"
  },
  "page": {
    "plans": {
      "try-now": "Prøv nu",
      "what-included": "Hvad er inkluderet?",
      "popular-plan": "Populær"
    },
    "about-us": {
      "title": "Om os",
      "intro": "Goodchart blev grundlagt i 2023 med en mission om at forvandle din tøjshoppingoplevelse. Vores team af modeentusiaster, designere og teknologieksperter er her for at give dig mulighed for at finde tøj, der virkelig komplementerer din krop. Med vores brugervenlige interface og avancerede algoritmer giver vi personlige anbefalinger baseret på dine mål, stil og livsstil.",
      "community": "Sig farvel til kompromiser og goddag til selvtillid og komfort. Bliv en del af vores inkluderende fællesskab af tilfredse kunder, og begiv dig ud på en glædelig shoppingrejse med Goodchart.",
      "tagline": "Udfold din stil. Oplev ren modeeufori.",
      "founders": "Stiftere",
      "cedric-photo-alt": "Cedric, medstifter af Goodchart og produktchef",
      "nick-photo-alt": "Nick, medstifter af Goodchart og driftsdirektør",
      "quentin-photo-alt": "Quentin, IT-chef hos Goodchart",
      "cedric": "Cedric",
      "cedric-role": "Medstifter af Goodchart og produktchef",
      "nick": "Nick",
      "nick-role": "Medstifter af Goodchart og driftsdirektør",
      "quentin": "Quentin",
      "quentin-role": "IT-chef hos Goodchart"
    },
    "contact": {
      "title": "Kontakt os",
      "lets-talk": "Lad os tale sammen",
      "subtitle": "Udfyld formularen, så kontakter vores team dig via e-mail.",
      "first-name": "Fornavn",
      "first-name-required": "Fornavn er påkrævet",
      "last-name": "Efternavn",
      "last-name-required": "Efternavn er påkrævet",
      "email": "E-mail",
      "email-required": "E-mail er påkrævet",
      "email-invalid": "Indtast venligst en gyldig e-mailadresse",
      "message": "Besked",
      "message-required": "Besked er påkrævet",
      "sending": "Sender...",
      "send": "Send",
      "success": "Din formular er blevet sendt til vores team!"
    },
    "email-unsubscribe": {
      "title": "E-mailabonnement",
      "unsubscribe-confirm": "Er du sikker på, at du vil afmelde dig vores nyhedsbrev?",
      "unsubscribe-info": "Ved at afmelde dig vil du ikke længere modtage opdateringer, nyhedsbreve og særlige tilbud fra os.",
      "cancel": "Annullér",
      "confirm-unsubscription": "Bekræft afmelding",
      "resubscribe-confirm": "Vil du gerne tilmelde dig vores nyhedsbrev igen?",
      "resubscribe-info": "Hold dig opdateret med vores seneste nyheder, eksklusive tilbud og spændende opdateringer.",
      "resubscribe": "Tilmeld igen",
      "unsubscribe-success": "Din e-mail blev afmeldt",
      "unsubscribe-error": "Der opstod et problem med at afmelde din e-mail",
      "resubscribe-success": "Din e-mail blev gentilmeldt",
      "resubscribe-error": "Der opstod et problem med at gentilmelde din e-mail"
    },
    "back-to-stock": {
      "notify-me-product": "Giv mig besked om produktet {{title}} - {{variant}}"
    },
    "help": {
      "title": "Hjælpecenter",
      "description": "Vejledninger i at opsætte og bruge Goodchart i din Shopify-butik.",
      "search": "Søg i hjælpeartikler",
      "loading": "Indlæser…",
      "load-failed": "Hjælpecenteret kunne ikke indlæses. Prøv igen om lidt.",
      "no-results": "Ingen artikler matcher din søgning.",
      "no-articles": "Der er endnu ingen hjælpeartikler.",
      "topics": {
        "getting-started": "Kom godt i gang",
        "size-charts": "Størrelsesguider",
        "table-charts": "Tabelguider",
        "assigning-products": "Tildeling af produkter",
        "storefront-display": "Visning i butikken",
        "chart-import": "Import af guider",
        "size-recommendations": "Størrelsesanbefalinger",
        "plans-billing": "Abonnementer og fakturering",
        "troubleshooting": "Fejlfinding"
      },
      "back": "Tilbage til hjælpecenteret",
      "browse": "Gå til hjælpecenteret",
      "not-found": {
        "title": "Artiklen blev ikke fundet",
        "description": "Denne artikel findes ikke eller er ikke længere tilgængelig."
      },
      "updated": "Senest opdateret {{date}}",
      "related": "Mere om {{topic}}",
      "contact": {
        "title": "Brug for mere hjælp?",
        "description": "Send os en besked, så vender vores team tilbage til dig via e-mail. Har du Goodchart-appen installeret, kan du også spørge i dens supportchat.",
        "link": "Kontakt os"
      },
      "article-load-failed": "Artiklen kunne ikke indlæses. Prøv igen om lidt."
    }
  },
  "error": {
    "error-occurred": "Der opstod en fejl!",
    "failed-to-subscribe-to-this-product": "Kunne ikke abonnere på dette produkt!",
    "failed-to-get-your-size-recommendation-please-try-again-later": "Kunne ikke hente din størrelsesanbefaling. Prøv venligst igen senere."
  },
  "common": {
    "close": "Luk"
  },
  "component": {
    "size-recommender": {
      "form": {
        "title": "Find din bedste størrelse",
        "subtitle": "Et par hurtige detaljer for en bedre pasform",
        "shopping-for": "SHOPPER TIL",
        "gender-women": "Kvinder",
        "gender-men": "Mænd",
        "gender-other": "Andet",
        "measurements": "MÅL",
        "height": "Højde",
        "height-required": "Højde er påkrævet",
        "height-min": "Mindste højde er 1",
        "weight": "Vægt",
        "weight-required": "Vægt er påkrævet",
        "weight-min": "Mindste vægt er 1",
        "preferred-fit": "Foretrukken pasform",
        "continue": "Fortsæt"
      },
      "result": {
        "suggested-size": "Foreslået størrelse:",
        "no-fit": "Det ser desværre ud til, at vi ikke har en ideel størrelse lige nu. Vi anbefaler, at du kigger igen senere for flere muligheder.",
        "verdict": "Dom:",
        "similar-variants": "Lignende varianter:",
        "proceed": "Fortsæt med denne variant",
        "estimate-disclaimer": "(Estimat baseret på brand og brugeroplysninger, resultater kan variere.)",
        "back": "Tilbage"
      }
    },
    "footer": {
      "terms": "Vilkår",
      "privacy": "Privatliv",
      "help-center": "Hjælpecenter",
      "blog": "Blog",
      "about": "Om",
      "contact-us": "Kontakt os"
    },
    "conversion-table": {
      "description": "Afhængigt af pasformen kan der forekomme mindre forskelle i mål. Find din korrekte størrelse i tabellen nedenfor.",
      "size": "Størrelse"
    },
    "add-to-cart-btn": {
      "notify-me-when-available": "Giv mig besked, når den er tilgængelig",
      "notify-me": "Giv mig besked",
      "out-of-stock": "Udsolgt"
    },
    "restock-form": {
      "your-name": "Dit navn",
      "your-email": "Din e-mailadresse",
      "email-required": "E-mail er påkrævet",
      "subscribing": "Tilmelder...",
      "notify-me": "GIV MIG BESKED",
      "agree-terms": "Ved at fortsætte accepterer du vores",
      "terms-privacy": "Vilkår og privatlivspolitik",
      "news-opt-in": "Jeg vil gerne modtage opdateringer om nye lanceringer og andet inspirerende indhold (valgfrit)"
    },
    "back-to-stock-result": {
      "new-subscription": "Tak, vi sender dig en e-mail, når størrelse <span class=\"font-bold\">{{name}}</span> er tilgængelig.",
      "existing-subscription": "Vi har din e-mail! Vi giver dig besked, så snart størrelse <span class=\"font-bold\">{{name}}</span> er tilbage på lager.",
      "back-to-collection": "Tilbage til kollektionen"
    },
    "chart": {
      "find-your-size": "Find din størrelse",
      "size-guide": "Størrelsesguide",
      "recommendation": "Anbefaling",
      "body-measurements": "KROPSMÅL",
      "model-measurements": "MODELMÅL",
      "model-description": "Model {{name}} er {{height}}cm og bærer størrelse {{variant}}.",
      "size-conversion": "STØRRELSESKONVERTERING"
    },
    "landing": {
      "learn": "Lær",
      "learn-more": "Læs mere",
      "blog": "Blog",
      "blog-description": "Udforsk de seneste meddelelser, produktopdateringer og mere",
      "help-center": "Hjælpecenter",
      "help-center-description": "Kom godt i gang, how-to-artikler og trin-for-trin-instruktioner",
      "demo": "Demo",
      "demo-description": "Se Goodsize-widgets i aktion i vores eksempelbutik",
      "services": "TJENESTER",
      "contact": "Kontakt",
      "privacy": "Privatliv",
      "goodsize": "Goodsize",
      "goodsize-description": "Opdag vores pasformsløsning til din virksomhed",
      "goodchart": "Goodchart",
      "goodchart-description": "Visuel størrelsestabel til at øge konverteringen"
    },
    "product-variant-completer": {
      "title": "Vælg dine muligheder",
      "body": "Vælg din {{option}} for at fortsætte.",
      "body-multiple": "Vælg de resterende muligheder for at fortsætte.",
      "body-notify": "Hvilken {{option}} skal vi holde øje med for dig?",
      "confirm": "Fortsæt",
      "cancel": "Annuller",
      "empty": "Denne kombination er ikke tilgængelig."
    },
    "checkout-variant": {
      "label": "Du køber {{variant}}",
      "aria-label": "Skift den variant, du køber",
      "sold-out": "udsolgt"
    }
  },
  "promotion": {
    "BlackFriday": {
      "name": "Black Friday"
    }
  }
}
